import { render, staticRenderFns } from "./AuthorInfoHeader.vue?vue&type=template&id=fb5f3d82&scoped=true"
import script from "./AuthorInfoHeader.vue?vue&type=script&lang=js"
export * from "./AuthorInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./AuthorInfoHeader.vue?vue&type=style&index=0&id=fb5f3d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5f3d82",
  null
  
)

export default component.exports